var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 14.2222V21.3333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 17.7778H22.2222",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5927 3.11089H17.3334C18.5586 3.11089 19.5556 4.10794 19.5556 5.33312V10.9998H18.0741V8.32574H3.25936V16.4442C3.25936 16.8524 3.59193 17.1849 4.00005 17.1849H12.0001V18.6665H4.00005C2.77488 18.6665 1.77783 17.6694 1.77783 16.4442V5.33312C1.77783 4.10794 2.77488 3.11089 4.00005 3.11089H4.74075V1.62937C4.74075 1.22057 5.07265 0.888672 5.48158 0.888672H6.22228C6.63121 0.888672 6.96297 1.22057 6.96297 1.62937V3.11089H14.3705V1.62937C14.3705 1.22057 14.7022 0.888672 15.1112 0.888672H15.8519C16.2608 0.888672 16.5927 1.22057 16.5927 1.62937V3.11089Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAgenda);
export default __webpack_public_path__ + "static/media/add_agenda.e5bec84640a7e23b2e8d927cb453010e.svg";
export { ForwardRef as ReactComponent };